<template>
  <div class="landing-container">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "HomeDashboard",
  components: {},
  data() {
    return {};
  },
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/layout/Landing.vue